import VueGtag, { trackRouter } from 'vue-gtag-next'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  nuxtApp.vueApp.use(VueGtag, {
    property: {
      id: 'G-ND2VYXFHB4',
      params: { cookie_flags: 'SameSite=None; Secure' },
    },
  })

  trackRouter(router, {
    useScreenview: true,
  })
})
